import React from 'react';
import { removeCollectionRegister } from '../../../../redux/actions/form';
import { serverRequest } from '../../../../utility/helpers/Axios/serverRequest';
import { useDispatch } from 'react-redux';
import { Input } from '../../form/Input';
import { Download, Link, Trash } from 'react-feather';

export const DocumentTable = ({
  documents,
  collection,
  endPoint,
  id,
  targetId,
}) => {
  const dispatch = useDispatch();

  const handleDownload = async (filePath, filename, i, filetype) => {
    await serverRequest(
      'document',
      null,
      { endPoint, id: id || targetId, path: filePath, responseType: 'blob' },
      'POST',
    ).then((data) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.${filetype}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleRemoveFile = async (i, path) => {
    dispatch(removeCollectionRegister(['documents'], i));
    await serverRequest(
      endPoint,
      id || targetId,
      { extraUrl: 'unlinkFile', path },
      'POST',
      true,
    );
  };

  const getFileSize = (size, index = 0) => {
    const sizeExtensions = ['B', 'KB', 'MB', 'GB'];
    if (size > 1024) return getFileSize(size / 1000, index + 1);
    else return `${size.toFixed(2)} ${sizeExtensions[index]}`;
  };

  return (
    <div style={{ overflow: 'hidden' }} className="rounded mt-1">
      <table className="table-documents table-striped ">
        <thead>
          <tr>
            <th className="w-5"></th>
            <th className="w-45">Nombre</th>
            <th className="w-20">Tipo</th>
            <th className="w-20">Fecha</th>
            <th className="text-right w-5">Tamaño</th>
            <th className="w-5"></th>
          </tr>
        </thead>
        <tbody>
          {documents?.map((file, i) => (
            <tr key={file.path}>
              <td>
                {file.id && (
                  <Download
                    className="cursor-pointer"
                    size={11}
                    onClick={() =>
                      handleDownload(
                        file.path,
                        file.name,
                        i,
                        file.type.split('/')[1],
                      )
                    }
                  />
                )}
              </td>
              <td>
                <Input
                  className="form-control form-control-sm"
                  containerClassname=""
                  name="name"
                  collection={[...collection, i]}
                  placeholder="Nombre del archivo"
                />
              </td>
              <td>{file.type}</td>
              <td>
                <Input
                  className="form-control form-control-sm"
                  containerClassname=""
                  name="date"
                  type="date"
                  collection={[...collection, i]}
                />
              </td>
              <td className="text-right fw-bold">{getFileSize(file.size)}</td>
              <td className="text-center">
                <Trash
                  className="cursor-pointer"
                  size={11}
                  onClick={() => handleRemoveFile(i, file.path)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
